/* ============================================
   Any Questions Form Snippet — any-questions-form.js
   Supports multiple instances on the same page.
   ============================================ */

(function () {
  'use strict';

  /* ── UTM Params ───────────────────────────────── */
  function getUTM() {
    var p = new URLSearchParams(window.location.search);
    return {
      utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
      utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
      utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
      gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
    };
  }

  /* ── Init One Form Instance ──────────────────── */
  function initForm(form) {
    if (!form || form.dataset.aqInitialized === 'true') return;
    form.dataset.aqInitialized = 'true';

    var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';

    var submitBtn = form.querySelector('[data-aq-submit]');
    var btnText   = form.querySelector('[data-aq-btn-text]');
    var btnLoader = form.querySelector('[data-aq-loader]');
    var apiError  = form.querySelector('[data-aq-error]');
    var successEl = form.querySelector('[data-aq-success]');
    var grid      = form.querySelector('[data-aq-grid]');
    var btnWrap   = form.querySelector('[data-aq-btn-wrap]');

    /* ── Helpers scoped to this form ──────────── */
    function setLoading(on) {
      if (submitBtn) submitBtn.disabled = on;
      if (btnText)   btnText.style.display   = on ? 'none' : 'inline-flex';
      if (btnLoader) btnLoader.style.display = on ? 'inline-block' : 'none';
    }

    function clearErrors() {
      if (apiError) {
        apiError.style.display = 'none';
        apiError.textContent   = '';
      }
      form.querySelectorAll('.aq-field-error').forEach(function (el) {
        el.classList.remove('aq-field-error');
      });
    }

    function getField(name) {
      return form.querySelector('[data-aq-field="' + name + '"]');
    }

    function markError(name) {
      var el = getField(name);
      if (el) el.classList.add('aq-field-error');
    }

    /* Removes a country code the visitor typed themselves, so it is not added twice:
       with +91 selected, "+91 98765 43210", "919876543210" and "09876543210" all become 9876543210.
       Separators are dropped. A "+" number for a different country is left as is (and fails the
       digits check), so the visitor sees the field flagged instead of a wrong number being saved. */
    function normalizeForCode(raw, code) {
      var v = String(raw || '').replace(/[\s\-().]/g, '');
      var cc = String(code || '+91').replace(/\D/g, '');
      if (v.charAt(0) === '+') {
        return v.indexOf('+' + cc) === 0 ? v.slice(cc.length + 1) : v;
      }
      if (cc === '91') {
        var m = v.match(/^(?:91|0)(\d{10})$/);
        if (m) return m[1];
      }
      return v;
    }

    function validate(d) {
      var ok = true;
      if (!d.Company)   { markError('company');   ok = false; }
      if (!d.Name)      { markError('name');      ok = false; }
      if (!d.QueryType) { markError('queryType'); ok = false; }

      if (!d.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.Email)) {
        markError('email'); ok = false;
      }

      // Mobile is optional; if entered, must be 7-15 digits
      if (d.Mobile && !/^\d{7,15}$/.test(d.Mobile)) {
        markError('mobile'); ok = false;
      }
      return ok;
    }

    function showSuccess() {
      form.reset();
      if (grid)      grid.style.display      = 'none';
      if (btnWrap)   btnWrap.style.display   = 'none';
      if (successEl) {
        successEl.style.display = 'block';
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* ── Numeric-only restrictions ──────────────── */
    form.querySelectorAll('[data-aq-numeric="true"]').forEach(function (el) {
      el.addEventListener('input', function () {
        this.value = this.value.replace(/[^\d+\s\-()]/g, '');
      });
    });

    /* ── Submit ─────────────────────────────────── */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();

      var companyEl   = getField('company');
      var nameEl      = getField('name');
      var emailEl     = getField('email');
      var mobileEl    = getField('mobile');
      var countryEl   = getField('countryCode');
      var queryEl     = getField('queryType');

      var data = {
        Company:     companyEl ? companyEl.value.trim() : '',
        Name:        nameEl    ? nameEl.value.trim()    : '',
        Email:       emailEl   ? emailEl.value.trim()   : '',
        Mobile:      mobileEl  ? mobileEl.value.trim()  : '',
        CountryCode: countryEl ? countryEl.value        : '+91',
        QueryType:   queryEl   ? queryEl.value.trim()   : ''
      };

      data.Mobile = normalizeForCode(data.Mobile, data.CountryCode);
      if (!validate(data)) {
        if (apiError) {
          apiError.textContent   = '❌ Please fill in all required fields correctly.';
          apiError.style.display = 'block';
        }
        return;
      }

      var utm = getUTM();
      var mobileWithCode = data.Mobile ? (data.CountryCode + data.Mobile) : '';

      setLoading(true);

      // ── Send to Google Sheet (also forwards to CRM server-side) ──
      fetch(SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formName    : 'AnyQuestions',
          company     : data.Company,
          name        : data.Name,
          email       : data.Email,
          mobile      : mobileWithCode,
          product     : data.QueryType,
          query_type  : data.QueryType,
          message     : 'Any Questions Form | Query Type: ' + data.QueryType,
          utm_source  : utm.utm_source,
          utm_medium  : utm.utm_medium,
          utm_campaign: utm.utm_campaign,
          gclid       : utm.gclid
        })
      })
        .then(function () {
          setLoading(false);
          showSuccess();
        })
        .catch(function (err) {
          console.error('Any Questions Submit Error:', err);
          setLoading(false);
          if (apiError) {
            apiError.textContent   = '❌ Something went wrong. Please try again.';
            apiError.style.display = 'block';
          }
        });
    });
  }

  /* ── Init All Forms on Page ──────────────────── */
  function initAll() {
    document.querySelectorAll('form.aq-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', initAll);

})();